export default "__VITE_ASSET__DsylV5ns__"